import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from '../../../../../i18next';
import { Container, Row, Button, Col, Form, Input } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';

import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../../../../utils/Constants';
import SearchButton from '../../../../common/SearchButton';
import { downloadInvoice, getInvoices } from '../../../../../actions';
import { getCurrencySymbol, transformProductPrice } from '../../../../../utils/CommonUtils';
class Invoices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: {
                week: '',
                month: '',
                year: '',
                restaurantId: ''
            },
            fromDate: null,
            toDate: null,
            total: null,
            currentPageNumber: 0
        }

        this.search = this.search.bind(this);
        this.changeState = this.changeState.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {

        const restaurantId = this.props.match.params.id;

        this.setState({
            ...this.state,
            searchQuery: {
                ...this.state.searchQuery,
                restaurantId: restaurantId
            }
        }, () => {
            this.props.getInvoices(this.state.currentPageNumber, this.state.searchQuery)
        })
    }

    downloadChanges(activityId) {
        // this.props.downloadInvoice(activityId)
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    search() {
        this.props.getInvoices(this.state.currentPageNumber, this.state.searchQuery);
    }

    clearSearch() {

        this.setState({
            ...this.state,
            searchQuery: {
                ...this.state.searchQuery,
                week: '',
                month: '',
                year: ''
            },
            currentPageNumber: 0
        }, () => this.props.getInvoices(this.state.currentPageNumber, this.state.searchQuery));
    }

    handlePageChange(pageNumber) {
        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.getInvoices(this.state.currentPageNumber, this.state.searchQuery));
    }

    changeState = ({ target }) => {

        this.setState({
            currentPageNumber: 0,
            searchQuery: {
                ...this.state.searchQuery,
                [target.name]: target.value
            },
        });
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderDownloadButton = (restaurantId, week, year, month) => {

        return (
            <Button color="link" onClick={() => this.props.downloadInvoice(restaurantId, week, year, month)} style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '5px' }}>
                    <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                </span>
                {i18n.t('screens:eventTrackingScreen.download')}
            </Button>
        )
    }

    renderPagination() {
        const { flexEnd } = styles;
        const { invoices } = this.props.restaurant;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={invoices && invoices.content ? invoices.number + 1 : null}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={invoices && invoices.content ? invoices.totalElements : null}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.invoices')}</span>
            </div>
        );
    }


    renderSearch() {
        const { week, year, month } = this.state.searchQuery;
        const { paddingLeftRight } = styles;

        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }} xs="auto" sm={12} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col style={paddingLeftRight}>
                            <Input 
                            type="number" 
                            name="week" 
                            id="week" 
                            placeholder={i18n.t('screens:paymentScreen.week')} 
                            value={week} 
                            onChange={this.changeState}
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input 
                            type="number" 
                            name="month" 
                            id="month" 
                            placeholder={i18n.t('screens:paymentScreen.month')} 
                            value={month} 
                            onChange={this.changeState} 
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input 
                            type="number" 
                            name="year" 
                            id="year" 
                            placeholder={i18n.t('screens:paymentScreen.year')} 
                            value={year} 
                            onChange={this.changeState} 
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)}/>
                        </Col>
                        <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0, marginLeft: '15px' }}>
                            <SearchButton search={this.search} />
                            <Button
                                color="link"
                                style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                onClick={() => this.clearSearch()}>{i18n.t('common:searchForms.clear')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
        )
    }

    renderTable() {
        const { invoices } = this.props.restaurant
        const { headerContainer } = styles

        return (
            <Col style={{ padding: '0px' }}>
                <Row style={headerContainer}>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.week')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.month')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.year')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.fromDate')}</Col>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.toDate')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.inv')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.total')}</Col>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.transferTotal')}</Col>
                    <Col xs={1}>{i18n.t('common:buttons.download')}</Col>
                </Row>
                {
                    invoices && invoices.content && invoices.content.length ?
                        this.renderTableRows() :
                        <Col style={{ width: '90%', padding: '15px 15px 0', borderBottom: '1px solid #dee2e6' }}>
                            <p style={{ fontSize: '14px' }}>{i18n.t('screens:centralOrdersLog.noResults')}</p>
                        </Col>
                }
                <Col style={{ paddingRight: '0px' }}>{this.renderPagination()}</Col>
            </Col>
        );
    }

    renderTableRows() {

        const { headerContainer } = styles;
        const { invoices } = this.props.restaurant;
        const content = invoices.content ? invoices.content : null;
        
        if (content !== undefined && content !== null && content.length) {
            return content.map((order, i) => {

                return (
                    <Row key={i} style={headerContainer}>
                        <Col xs={1}>{order.week}</Col>
                        <Col xs={1}>{order.month}</Col>
                        <Col xs={1}>{order.year}</Col>
                        <Col xs={1}>{order.fromDate}</Col>
                        <Col xs={2}>{order.toDate}</Col>
                        <Col xs={1}><span>{transformProductPrice(Number(order.total))}</span><span>{getCurrencySymbol(this.props.restaurant.currency)}</span></Col>
                        <Col xs={1}><span>{transformProductPrice(Number(order.totalRevenue))}</span><span>{getCurrencySymbol(this.props.restaurant.currency)}</span></Col>
                        <Col xs={2}>{order.transferTotal ? <span>{transformProductPrice(Number(order.transferTotal))} {getCurrencySymbol(this.props.restaurant.currency)}</span> : '-'}</Col>
                        <Col xs={1} style={{ display: 'flex', justifyContent: 'center' }}>{this.renderDownloadButton(order.restaurantId, order.week, order.month, order.year)}</Col>
                    </Row>
                )
            })
        }
    }


    render() {
        const { containerStyle } = styles;

        return (
            <Container fluid style={containerStyle}>
                <Row>{this.renderHeader()}</Row>
                <Row>{this.renderSearch()}</Row>
                <Row>{this.renderTable()}</Row>
            </Container>
        );
    }
}

const mapStateToProps = state => {

    return {
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, {getInvoices, downloadInvoice})(Invoices);

let styles = {
    headerContainer: {
        width: '100%',
        height: '45px',
        margin: 0,
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        backgroundColor: '#F8F8F8',
        paddingRight: '10px'
    },
    paddingLeftRight: {
        maxWidth: '180px',
        paddingLeft: 5,
        paddingRight: 0,
        marginBottom: 5
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingRight: 0
    },
    spaceBetween: {
        paddingLeft: 4,
        marginTop: -3
    },
    headerStyle: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        paddingTop: 10,
        paddingLeft: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/Invoices.js